import { Tv, Star } from 'lucide-react';
import '@/Sections.css';

const CLIENTS = ['WINSTAGE', 'Indian Living', 'La Pelote', 'W24', 'Beate Glatz', 'WinPark West'];

export default function TrustBar() {
  return (
    <section className="trust-section" data-testid="trust-section">
      <div className="container">
        <p className="trust-label" data-reveal>Vertraut von Unternehmen & Künstlern aus Wien und Niederösterreich</p>
        <div className="trust-chips" data-reveal="stagger">
          {CLIENTS.map((c) => (
            <span className="trust-chip" key={c}>{c}</span>
          ))}
        </div>
        <div className="trust-badges" data-reveal>
          <span className="trust-badge" data-testid="trust-badge-tv">
            <Tv size={16} /> Unsere KI-Spots laufen im regionalen TV
          </span>
          <a
            className="trust-badge trust-badge-link"
            href="https://www.google.com/maps?q=Maisblau+Videoproduktion+Wien"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="trust-badge-google"
          >
            <Star size={16} /> Google-Bewertungen ansehen
          </a>
        </div>
      </div>
    </section>
  );
}
